__turbopack_context__.v({
  "checkContent": "Tools-module__PAnbbW__checkContent",
  "checkItem": "Tools-module__PAnbbW__checkItem",
  "checkText": "Tools-module__PAnbbW__checkText",
  "checkTitle": "Tools-module__PAnbbW__checkTitle",
  "checks": "Tools-module__PAnbbW__checks",
  "container": "Tools-module__PAnbbW__container",
  "groupLabel": "Tools-module__PAnbbW__groupLabel",
  "groupLabelAvailable": "Tools-module__PAnbbW__groupLabelAvailable",
  "groupLabelUpcoming": "Tools-module__PAnbbW__groupLabelUpcoming",
  "intro": "Tools-module__PAnbbW__intro",
  "introSupTitle": "Tools-module__PAnbbW__introSupTitle",
  "introText": "Tools-module__PAnbbW__introText",
  "introTitle": "Tools-module__PAnbbW__introTitle",
  "introTitles": "Tools-module__PAnbbW__introTitles",
  "toolAction": "Tools-module__PAnbbW__toolAction",
  "toolCard": "Tools-module__PAnbbW__toolCard",
  "toolDesc": "Tools-module__PAnbbW__toolDesc",
  "toolHeader": "Tools-module__PAnbbW__toolHeader",
  "toolIcon": "Tools-module__PAnbbW__toolIcon",
  "toolNumber": "Tools-module__PAnbbW__toolNumber",
  "toolStar": "Tools-module__PAnbbW__toolStar",
  "toolTitle": "Tools-module__PAnbbW__toolTitle",
  "toolsGrid": "Tools-module__PAnbbW__toolsGrid",
  "toolsGroup": "Tools-module__PAnbbW__toolsGroup",
});
